import type { MultiFactorAuthStore } from '@/features/iam/auth/MultiFactorAuthStore'
import { computed } from 'mobx'
import { task } from 'mobx-task'

export class SecurityViewModel {
  constructor(private readonly _store: MultiFactorAuthStore) {}

  /**
   * Determines whether the user is enrolled in multi-factor authentication.
   */
  @computed
  get isUserEnrolled() {
    return this._store.isUserEnrolled
  }

  /**
   * Gets an MFA enrollment URL.
   */
  fetchEnrollmentUrl = task.resolved(async () => {
    return this._store.fetchEnrollmentUrl()
  })
}
